import SearchResultsListLoading from "features/SearchResultsList/components/SearchResultsListLoading";

export default function BookmarkListLoading() {
  return (
    <div className="px-4 m-auto mt-32 max-w-page">
      <SearchResultsListLoading />
    </div>
  );
}
